<template>
  <div>
    <template>
      <v-data-table
        class="custom-detail-plan-data-table rounded-lg"
        :class="{ 'single-class': single }"
        :no-data-text="$t('common.nodata')"
        :headers="columns"
        :items="itemData"
        disable-pagination
        disable-filtering
        disable-sort
        hide-default-footer
        mobile-breakpoint="801"
      >
        <template v-slot:item.duration="{ item }">
          <div class="d-flex align-center" style="gap: 8px">
            <div style="width: 18px;">
              <v-icon
                clr="var(--v-onPrimary-base)"
                v-if="item.minApy && item.maxApy"
                size="18"
                >$flexible</v-icon
              >
            </div>

            <v-img
              v-if="single"
              :src="logoUrl"
              max-width="40"
              :alt="coinUnit"
            />
            <span>{{ item.duration }} {{ $t("common.day") }}</span>
          </div>
        </template>
        <template v-slot:item.activeAPY="{ item }">
          <!--          this is flexible apr-->
          <template v-if="item.minApy && item.maxApy" dir="ltr">
            <div class="d-flex align-center justify-center" style="gap: 4px">
              <span>% {{ item.maxApy }}</span>
              <span class="success--text font-Bold-14"
                >{{ item.activeAPY }}%≈</span
              >
              <span>% {{ item.minApy }}</span>
            </div>
          </template>
          <!--          this is active apr-->
          <template v-else>
            <span>% {{ item.activeAPY }} </span>
          </template>
        </template>
        <template v-slot:item.releaseDuration="{ item }">
          <button>
            {{
              $t("staking.stakingDetailPage.oneDayAfterPlanCompletion", {
                day: item.releaseDuration
              })
            }}
          </button>
        </template>
        <template v-slot:item.minStakePerUser="{ item }">
          <button>
            {{ $thousandMask(item.minStakePerUser) }} {{ coinUnit }}
          </button>
        </template>
        <template v-slot:item.remainCapacity="{ item }">
          <div>
            {{ $thousandMask(item.remainCapacity) }} {{ $t("common.from") }}
            {{ $thousandMask(item.maxCapacity) }} {{ coinUnit }}
          </div>
        </template>
        <template v-slot:item.endDate="{ item }">
          <button v-if="!isExpireTime(item.endDate)">
            {{ item.endDate | formatDate }}
          </button>
          <span v-else class="error--text">{{
            $t("staking.stakingPlans.plans.details.expireTime")
          }}</span>
        </template>
        <template v-slot:item.isRenewal="{ item }">
          <span>
            {{
              item.isRenewal
                ? $t("staking.stakingPlans.plans.details.existed")
                : $t("staking.stakingPlans.plans.details.notExisted")
            }}
          </span>
        </template>
        <template v-slot:item.status="{ item }">
          <div :class="{ 'disabled-cursor': !item.canStake }">
            <v-btn
              :disabled="!item.canStake"
              min-width="147"
              width="100%"
              color="primary"
              @click="() => joinPlanHandler(item.planDetailId)"
            >
              <!--            <span v-if="item.isRegisterEnded">{{-->
              <!--              $t("staking.stakingPlans.plans.details.expirePlan")-->
              <!--            }}</span>-->
              <!--            <span v-else-if="item.isRegisterNotStarted">-->
              <!--              {{-->
              <!--                $t("staking.stakingPlans.plans.details.openNotificationSent")-->
              <!--              }}-->
              <!--            </span>-->
              <span>{{
                item.canStake
                  ? $t("staking.stakingPlans.plans.details.joinedStaking")
                  : $t("common.registrationClosed")
              }}</span>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import dayjs from "dayjs";
import $thousandMask from "@/mixins/thousandMask";

export default {
  mixins: [$thousandMask],
  props: {
    itemData: {
      type: Array
    },
    coinUnit: String,
    logoUrl: String,
    stakingPlanId: Number,
    single: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // this.isFlexible = !!planDetail.maxApy && !!planDetail.minApy;
      columns: [
        {
          value: "duration",
          align: "center",
          text: this.$t("staking.stakingPlans.plans.details.planDuration"),
          width: "100px"
        },
        {
          value: "activeAPY",
          align: "center",
          text: this.$t("staking.stakingPlans.plans.details.apr"),
          width: "200px"
        },
        {
          value: "releaseDuration",
          align: "center",
          text: this.$t("staking.stakingPlans.plans.details.unlockDelay"),
          width: "150px"
        },
        {
          value: "minStakePerUser",
          align: "center",
          text: this.$t("staking.stakingPlans.plans.details.minMaxLimit"),
          width: "180px"
        },
        {
          value: "remainCapacity",
          align: "center",
          text: this.$t("staking.stakingPlans.plans.details.availableToStake"),
          width: "200px"
        },
        {
          value: "endDate",
          align: "center",
          text: this.$t("staking.stakingPlans.plans.details.endDate"),
          width: "150px"
        },
        {
          value: "isRenewal",
          align: "center",
          text: this.$t("staking.stakingPlans.plans.details.autoRenew"),
          width: "150px"
        },
        {
          value: "status",
          text: "",
          width: "200px"
        }
      ]
    };
  },
  methods: {
    joinPlanHandler(id) {
      this.$router.push(`/staking/${id}`);
    },
    isExpireTime(time) {
      const now = dayjs();
      return dayjs(time).isBefore(now);
    }
  }
};
</script>

<style lang="scss">
.disabled-cursor {
  cursor: not-allowed !important; /* Use !important to ensure it overrides default styles */
}
.single-class .v-data-table__wrapper {
  margin-bottom: 24px;
}
.custom-detail-plan-data-table thead {
  height: 45px;
}
.custom-detail-plan-data-table thead tr {
  background-color: var(--v-gray7-base) !important;
}
.custom-detail-plan-data-table thead th {
  border: none !important;
  background-color: unset !important;
  color: var(--v-onPrimary-base) !important;
  font-size: 16px;
  font-weight: 400;
}
.custom-detail-plan-data-table thead th:first-of-type,
.custom-detail-plan-data-table thead th:last-of-type {
  border-bottom-left-radius: 0 !important ;
  border-bottom-right-radius: 0 !important;
}

.custom-detail-plan-data-table tbody tr td {
  //width: 150px;
  color: var(--v-onPrimary-base) !important;
  padding: 20px !important;
}

@media screen and (max-width: 768px) {
  .custom-detail-plan-data-table tbody tr td {
    width: 100%;
  }
}
.custom-detail-plan-data-table tbody tr td:last-of-type {
  border-radius: 0 !important;
}
.custom-detail-plan-data-table tbody tr td:first-of-type {
  border-radius: 0 !important;
}

.custom-detail-plan-data-table tbody tr {
  background-color: var(--v-gray10-base) !important;
  border-radius: 0 !important;
  cursor: unset !important;
}

//mobile
.custom-detail-plan-data-table tbody {
  background-color: var(--v-gray13-base) !important;
}

.v-data-table__mobile-row:last-child .v-data-table__mobile-row__cell {
  width: 50%;
  margin: 0 auto;
}
@media screen and (max-width: 400px) {
  .v-data-table__mobile-row:last-child .v-data-table__mobile-row__cell {
    width: 100% !important;
  }
}
</style>
